import React from 'react';
import { ErrorState } from './ErrorState';

/**
 * The strip over data that a refetch could not replace: what was there stays,
 * and this says it may be out of date. Without data, the error takes the place
 * of the content instead (see `ErrorState`).
 *
 * @param {object} props
 * @param {string} props.error - The sentence from `extractApiError`.
 * @param {() => void} [props.onRetry]
 * @param {string} props.testId
 * @param {string} [props.className]
 */
export const StaleDataNotice = ({ error, onRetry, testId, className }) => (
  <div data-testid={testId} className={className}>
    <ErrorState
      variant="inline"
      title="No se pudo cargar la información: lo que ves puede no estar al día."
      description={error}
      onRetry={onRetry}
    />
  </div>
);
